var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.492,
    height: 18.794,
    viewBox: "0 0 23.492 18.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "files-svgrepo-com",
    d: "M25.4,32.881l.623-.623A.881.881,0,0,0,25.4,32Zm2.349,2.349-.623.623a.881.881,0,0,0,.623.258Zm8.516,13.8H19.23v1.762H36.262Zm-18.5-1.468V35.23H16V47.564Zm1.468-13.8H25.4V32H19.23Zm5.544-.258,2.349,2.349,1.246-1.246L26.02,32.258ZM37.73,37.579v9.984h1.762V37.579Zm-9.984-1.468h8.516V34.349H27.746ZM19.23,49.032a1.468,1.468,0,0,1-1.468-1.468H16a3.23,3.23,0,0,0,3.23,3.23Zm17.032,1.762a3.23,3.23,0,0,0,3.23-3.23H37.73a1.468,1.468,0,0,1-1.468,1.468Zm3.23-13.214a3.23,3.23,0,0,0-3.23-3.23v1.762a1.468,1.468,0,0,1,1.468,1.468ZM17.762,35.23a1.468,1.468,0,0,1,1.468-1.468V32A3.23,3.23,0,0,0,16,35.23Z",
    transform: "translate(-16 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.8c1d13e0729545057bb353f80e154f64.svg";
export { ForwardRef as ReactComponent };